import { useAddPreviousSamplesModalStyles } from 'components/OrderForm/SamplesFormV1/components/SelectExistingSamplesModal/styles';

export const CustomLoadingOverlay = () => {
  const { classes } = useAddPreviousSamplesModalStyles();
  
  return (
    <div className={classes.loadingOverlay}>
      <div className={classes.loadingSpinner} />
      <span>Loading Data from Previous Materials at HistoWiz...</span>
    </div>
  );
};
